import { useState } from 'react';
import { faqs } from '@/mocks/comic';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于阅读体验的疑问
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            关于跳章、目录跳转与分卷阅读，这里都有答案。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? 'border-primary-300 bg-primary-50' : 'border-background-200 bg-background-100'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-lg`} aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}